import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-zinc-950">
      {/* Abstract Tech Background */}
      <div className="absolute inset-0 lab-grid opacity-20"></div>
      <div className="absolute top-1/4 right-0 w-[800px] h-[800px] bg-red-600/10 rounded-full blur-[120px] pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-8">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-zinc-900 border border-zinc-800 text-xs font-medium text-red-500 uppercase tracking-wider">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
            Next-Gen Recovery Tech
          </div>
          
          <h1 className="text-5xl md:text-7xl font-black leading-[1.1] tracking-tighter">
            DOMINATE <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-800">YOUR DOWNTIME.</span>
          </h1>
          
          <p className="text-lg md:text-xl text-zinc-400 max-w-lg leading-relaxed">
            Professional-grade recovery tools engineered for the dedicated athlete. Optimize readiness, relieve tension, and get back to peak performance faster.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <button className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-sm font-bold uppercase tracking-wider transition-all flex items-center justify-center gap-2 group">
              Shop The Lab
              <SafeIcon name="ArrowRight" className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button className="bg-zinc-900 hover:bg-zinc-800 text-white px-8 py-4 rounded-sm font-bold uppercase tracking-wider border border-zinc-800 transition-all">
              Explore The System
            </button>
          </div>
        </div>

        <div className="relative hidden lg:block">
          <div className="absolute inset-0 bg-gradient-to-tr from-zinc-950 via-transparent to-transparent z-10"></div>
          <img 
            src="https://images.unsplash.com/photo-1599058917212-d750089bc07e?auto=format&fit=crop&q=80&w=1000" 
            alt="Athlete recovering" 
            className="rounded-lg object-cover w-full h-[600px] grayscale contrast-125 opacity-80 mix-blend-luminosity"
          />
          {/* Tech overlay elements */}
          <div className="absolute top-10 -left-10 bg-zinc-900 border border-zinc-800 p-4 rounded-sm shadow-2xl z-20 flex items-center gap-4">
            <SafeIcon name="Activity" className="text-red-500 text-2xl" />
            <div>
              <div className="text-xs text-zinc-500 uppercase">Readiness Score</div>
              <div className="text-xl font-black text-white">94% OPTIMAL</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;